export enum DvmTemplates {
    Default = 'default',
    New = 'new'
}